<template>
	<div class="pop_filters_m pop_white-s pop_bege popup_wrap" style="display:block">
		<div class="popup_in">
			<div class="popup">
				<div class="popup_close stay_close close-animate">
					<a href="javascript:void(0);" @click.prevent="$modal.hide('m-filters')">
						<close-svg></close-svg>
					</a>
				</div>
				<div class="corner-top"></div>
				<div class="exists_icon">
					<carmella-svg></carmella-svg>
				</div>
				<div class="pop_frame">
					<h2 class="title25">סינון מוצרים</h2>

					<template v-for="filter in $store.state.productFilters" v-key="filter.name">
						<div
							class="filter_check"
							:class="{ active: filter.isActive }"
							v-if="filter.category_ids.includes(mainCategory.id) || filter.category_ids === '*'"
						>
							<a href="javascript:void(0);" @click="$store.commit('toggleProductFilter', filter.name)">
								{{ filter.name }}
								<img
									v-if="filter.image"
									:id="filter.image.id"
									:src="filter.image.src"
									:alt="filter.image.alt"
								/>
							</a>
						</div>
					</template>

					<div class="bt_green ease">
						<a href="javascript:void(0);" @click="filter">סנן</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CarmellaSvg from "../../assets/img/carmella.svg";
	import closeSvg from "../../assets/img/close.svg";
	export default {
		props: ["cat_id"],
		data() {
			return {
				vficon:
					window.wpData.home_url + "/wp-content/themes/carmella/carmella-vue/dist/img/vegan-friendly-icon.png"
			};
		},
		computed: {
			mainCategory() {
				let categories = this.$store.state.categories;
				let cat = categories.find(c => c.id == this.cat_id);

				if (cat.parent) {
					let parent = categories.find(c => c.id == cat.parent);
					return parent;
				} else {
					return cat;
				}
			}
		},
		methods: {
			filter(event) {
				this.$modal.hide("m-filters");
			}
		},
		components: {
			CarmellaSvg,
			closeSvg
		}
	};
</script>

<style scoped>
	#vegan-friendly-icon {
	}
</style>
